import { oneOf } from 'prop-types';
import styled from 'styled-components';

const className = (strings, props) => {
  const classNames = ['section']
    .concat(
      ['spacing']
        .map((name) => (props[name] ? `is-${props[name]}` : null))
        .filter((className) => !!className)
    )
    .join(' ');

  return classNames;
};

const Section = styled.section.attrs((props) => ({
  className: className`${props}`,
}))``;

Section.propTypes = {
  spacing: oneOf(['medium', 'large']),
};

Section.defaultProps = {
  spacing: undefined,
};

export default Section;
